import { Button, HStack, Tooltip } from "@chakra-ui/react";
import React from "react";
import { useApproveLeave, useLeaveRemind, useRecallLeave } from "../../services/employeeService";
import { FiCheck, FiX, FiRotateCcw, FiBell } from "react-icons/fi";

const ListOfLeave = ({ item, refetchLeave }) => {
  const { status, leave_id } = item;

  const { approveLeaveIsLoading, approveLeavePayload } = useApproveLeave((res) => refetchLeave());
  const { recallLeaveIsLoading, recallLeavePayload } = useRecallLeave((res) => refetchLeave());
  const { leaveRemindIsLoading, leaveRemindPayload } = useLeaveRemind((res) => refetchLeave());

  const handleApprove = (id, action) => {
    const payload = {
      leave_id: id,
      is_approved: action,
    };
    approveLeavePayload(payload);
  };

  const handleRecall = (id) => {
    const payload = {
      leave_id: id,
    };
    recallLeavePayload(payload);
  };

  const isPending = status === "Pending";
  const isApproved = status === "Approved";

  const opsLoading = approveLeaveIsLoading || recallLeaveIsLoading || leaveRemindIsLoading;

  return (
    <HStack spacing={2} flexWrap="wrap">
      <Tooltip label="Email a reminder to the assigned approver (pending only)" hasArrow>
        <Button
          leftIcon={<FiBell />}
          colorScheme="blue"
          variant="outline"
          size="sm"
          onClick={() => leaveRemindPayload(leave_id)}
          isLoading={leaveRemindIsLoading}
          isDisabled={!isPending || (opsLoading && !leaveRemindIsLoading)}
          borderRadius="8px"
          fontSize="sm"
          fontWeight="500"
        >
          Send reminder
        </Button>
      </Tooltip>

      <Button
        leftIcon={<FiX />}
        colorScheme="red"
        variant="outline"
        size="sm"
        onClick={() => handleApprove(leave_id, false)}
        isLoading={approveLeaveIsLoading}
        isDisabled={!isPending || opsLoading}
        borderRadius="8px"
        fontSize="sm"
        fontWeight="500"
        _hover={{ bg: "red.50" }}
      >
        Reject
      </Button>

      <Button
        leftIcon={<FiCheck />}
        colorScheme="green"
        variant="outline"
        size="sm"
        onClick={() => handleApprove(leave_id, true)}
        isLoading={approveLeaveIsLoading}
        isDisabled={!isPending || opsLoading}
        borderRadius="8px"
        fontSize="sm"
        fontWeight="500"
        _hover={{ bg: "green.50" }}
      >
        Approve
      </Button>

      <Button
        leftIcon={<FiRotateCcw />}
        colorScheme="gray"
        variant="outline"
        size="sm"
        onClick={() => handleRecall(leave_id)}
        isLoading={recallLeaveIsLoading}
        isDisabled={!isApproved || opsLoading}
        borderRadius="8px"
        fontSize="sm"
        fontWeight="500"
        _hover={{ bg: "gray.50" }}
      >
        Recall
      </Button>
    </HStack>
  );
};

export default ListOfLeave;
